export const FORM_STYLES = {
  sectionBorder: "1px solid #DBDBDB",
  sectionBorderRadius: "4px",
  sectionPadding: "20px",
  titleBackgroundColor: "#63B4FF33",
  titleColor: "#2979C3",
  titleBorderRadius: "10px",
  headerPaddingTop: "5px",
  headerPaddingRight: "20px",
  itemPaddingTop: "10px",
  itemPaddingTop20: "20px",
  dividerColor: "black",
  dividerWidth: "2px",
} as const;
